import React from "react";
import styled from "styled-components";

import { ProgressMark } from "./ProgressMark";

const RulerContainer = styled.div`
    position: relative;
    background: #f1f1f1;
    height: 40px;
    max-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
`;

const RulerMark = styled.span.attrs(({ leftPercents }) => ({
    style: {
        left: `calc(${leftPercents}% + 3px)`
    }
}))`
   position: absolute;
   top: 18px;
   font-family: monospace;
   font-size: 10px;
`;

export const Ruler = React.forwardRef(({ animationsDuration, progress, tickSizeMs, peekDisabled, onStartPeek, timelineHeight }, ref) => {
    const ticks = [];
    let tickMs = 0;
    while (tickMs < animationsDuration) {
        ticks.push({
            tickMs,
            x: tickMs / animationsDuration * 1000,
            isMajor: tickMs % (tickSizeMs * 5) === 0,
            isRegular: tickMs % tickSizeMs === 0
        });
        tickMs += tickSizeMs / 10;
    }

    const hideTinyTicks = animationsDuration / tickSizeMs > 50;

    return (
        <RulerContainer ref={ref}>
            <svg viewBox="0 0 1000 20" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", overflow: "visible" }} preserveAspectRatio="none">
                {ticks.filter(({ isMajor, isRegular }) => !hideTinyTicks || isMajor || isRegular)
                    .map(({ x, isMajor, isRegular }, idx) =>
                        <line key={idx} x1={x} y1={0} x2={x} y2={isMajor ? 16 : isRegular ? 10 : 5} strokeWidth={isMajor ? "1px" : isRegular ? "1px" : "0.5px"} stroke={isMajor ? "#777" : isRegular ? "#999" : "#bbb"} />
                    )}
            </svg>
            {ticks.filter(({ isMajor }) => isMajor)
                .map(({ x, tickMs }, idx) =>
                    <RulerMark key={idx} leftPercents={x / 10}>{(tickMs / 1000).toFixed(1)}s</RulerMark>
                )}
            <ProgressMark
                progress={progress}
                animationsDuration={animationsDuration}
                onStartPeek={onStartPeek}
                peekDisabled={peekDisabled}
                timelineHeight={timelineHeight}
            />
        </RulerContainer>);
});
Ruler.displayName = "Ruler";
